var React = require('react');

function Watch (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M19.531 3.231a1.5 1.5 0 00-1.48 1.253l-.79 4.747h14.458l-.79-4.747a1.5 1.5 0 00-1.48-1.253H19.53zm15.23 6l-.874-5.24A4.5 4.5 0 0029.45.231h-9.92a4.5 4.5 0 00-4.438 3.76l-.874 5.24H12.49a4.5 4.5 0 00-4.5 4.5v21a4.5 4.5 0 004.5 4.5h1.73l.873 5.24a4.5 4.5 0 004.438 3.76h9.918a4.5 4.5 0 004.438-3.76l.874-5.24h1.729a4.5 4.5 0 004.5-4.5v-21a4.5 4.5 0 00-4.5-4.5h-1.73zm-3.042 30H17.261l.79 4.747a1.5 1.5 0 001.48 1.253h9.918a1.5 1.5 0 001.48-1.253l.79-4.747zm-19.229-27a1.5 1.5 0 00-1.5 1.5v21a1.5 1.5 0 001.5 1.5h24a1.5 1.5 0 001.5-1.5v-21a1.5 1.5 0 00-1.5-1.5h-24z"}));
}

Watch.defaultProps = {"viewBox":"0 0 48 49"};

module.exports = Watch;

Watch.default = Watch;
